export const PRODUCT_CREATE_REQUEST = "PRODUCT_CREATE_REQUEST";
export const PRODUCT_CREATE_SUCCESS = "PRODUCT_CREATE_SUCCESS";
export const PRODUCT_CREATE_FAIL = "PRODUCT_CREATE_FAIL";
export const PRODUCT_CREATE_RESET = "PRODUCT_CREATE_RESET";

export const ALL_PRODUCTS_REQUEST = "ALL_PRODUCTS_REQUEST";
export const ALL_PRODUCTS_SUCCESS = "ALL_PRODUCTS_SUCCESS";
export const ALL_PRODUCTS_FAIL = "ALL_PRODUCTS_FAIL";



export const SINGLE_PRODUCT_REQUEST = "SINGLE_PRODUCT_REQUEST";
export const SINGLE_PRODUCT_SUCCESS = "SINGLE_PRODUCT_SUCCESS";
export const SINGLE_PRODUCT_FAIL = "SINGLE_PRODUCT_FAIL";


// BULK IMPORT
export const PRODUCT_IMPORT_REQUEST = "PRODUCT_IMPORT_REQUEST";
export const PRODUCT_IMPORT_PROGRESS = "PRODUCT_IMPORT_PROGRESS";
export const PRODUCT_IMPORT_SUCCESS = "PRODUCT_IMPORT_SUCCESS";
export const PRODUCT_IMPORT_FAIL = "PRODUCT_IMPORT_FAIL";
export const PRODUCT_IMPORT_RESET = "PRODUCT_IMPORT_RESET";


export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL";
export const UPDATE_PRODUCT_RESET = "UPDATE_PRODUCT_RESET";

// Delete Product
export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL";
export const DELETE_PRODUCT_RESET = "DELETE_PRODUCT_RESET";



export const CLEAR_ERRORS = "CLEAR_ERRORS";
